import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import loadable from '@loadable/component'

import { NO_DATA_MESSAGE } from '../../../utils/constants'
import PeriodicTotalReturns from './PeriodicTotalReturns'

const LoadableTotalReturnsPeriodicPerformance = loadable(
  () => import('./TotalReturnsPeriodicPerformance'),
  {
    ssr: false,
    fallback: (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
        aria-label="Loading Total Returns Performance"
        aria-busy="true"
      >
        <Typography variant="body1">Loading Performance Data...</Typography>
      </Box>
    ),
  }
)

const NoDataMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize,
  textAlign: 'center',
  margin: theme.spacing(4, 0),
}))

const PeriodicTotalReturnsWrapper = ({ data, period_code, presentation }) => {
  const safeData = data || {}
  const periodCode = period_code

  const showNoDataMessage =
    safeData &&
    safeData.periodicPerformance.every(
      (item) => !item.fundReturn && !item.indexReturns && !item.marketReturn
    )

  if (showNoDataMessage) {
    return <NoDataMessage>{NO_DATA_MESSAGE}</NoDataMessage>
  }

  return (
    <>
      <LoadableTotalReturnsPeriodicPerformance
        data={safeData}
        period_code={periodCode}
      />
      <PeriodicTotalReturns
        {...safeData}
        period_code={periodCode}
        {...presentation}
      />
    </>
  )
}

PeriodicTotalReturnsWrapper.propTypes = {
  data: PropTypes.any,
  presentation: PropTypes.any,
}

export default React.memo(PeriodicTotalReturnsWrapper)